import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import API_BASE_URL from "../../../helper.js";

// Function to show success modal
function showSuccessModal(message) {
    $("#successMessage").text(message);
    const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
    modal.show();
}

// ✅ MOVE OUTSIDE (ONLY CHANGE)
function loadAllServices() {
    $.ajax({
        url: `${API_BASE_URL}/api/service/all`,
        type: "GET",
        success: function (services) {

            services.reverse();
            let rows = "";

            services.forEach((service, index) => {
                rows += `
                    <tr>
                        <td>${index + 1}</td>
                        <td><img src="${API_BASE_URL}/assets/Images/${service.image}" width="80" height="80" /></td>
                        <td>${service.name}</td>
                        <td>${service.description}</td>
                        <td>
                            <button class="btn btn-primary btn-sm editServiceBtn" data-id="${service.id}">Edit</button>
                            <button class="btn btn-danger btn-sm mx-1 deleteServiceBtn" data-id="${service.id}">Delete</button>
                        </td>
                    </tr>
                `;
            });

            $("#allSeviceData").html(rows);
        },
        error: function (xhr) {
            console.error("Failed to fetch services", xhr);
        }
    });
}

// ✅ KEEP SAME
window.loadServices = function () {
    loadAllServices();
};

$(document).ready(function () {

    // Add Service
    $("#addServiceForm").submit(function (e) {
        e.preventDefault();

        const formData = new FormData();
        formData.append("name", $("#name").val());
        formData.append("description", $("#discription").val());
        formData.append("image", $("#image")[0].files[0]);

        $.ajax({
            url: `${API_BASE_URL}/api/service/add`,
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,

            success: function () {

                showSuccessModal("Service Added Successfully!");

                $("#addServiceForm")[0].reset();

                const serviceModal = window.bootstrap.Modal.getInstance(document.getElementById("serviceModal"));
                serviceModal.hide();

                loadAllServices(); 
            },

            error: function (xhr) {
                console.log(xhr);
                alert("Failed to add service!");
            }
        });
    });

    // OPEN EDIT MODAL
    $(document).on("click", ".editServiceBtn", function () {
        const id = $(this).data("id");

        $.ajax({
            url: `${API_BASE_URL}/api/service/get/${id}`,
            type: "GET",
            success: function (b) {

                $("#editId").val(b.id);
                $("#editName").val(b.name);
                $("#editDescription").val(b.description);

                new window.bootstrap.Modal(document.getElementById("editServiceModal")).show();
            },
            error: () => alert("Failed to fetch service data")
        });
    });

    // UPDATE Service
    $("#editServiceForm").submit(function (e) {
        e.preventDefault();

        const id = $("#editId").val();
        const formData = new FormData();

        formData.append("name", $("#editName").val());
        formData.append("description", $("#editDescription").val());

        if ($("#editImage")[0].files.length > 0) {
            formData.append("image", $("#editImage")[0].files[0]);
        }

        $.ajax({
            url: `${API_BASE_URL}/api/service/update/${id}`,
            type: "POST",
            contentType: false,
            processData: false,
            data: formData,
            success: function () {
                showSuccessModal("Service Updated Successfully!");
                loadAllServices();
                window.bootstrap.Modal.getInstance(document.getElementById("editServiceModal")).hide();
            },
            error: () => alert("Failed to update Service")
        });
    });

    // Delete Service
    $(document).on("click", ".deleteServiceBtn", function () {
        let id = $(this).data("id");

        if (!window.confirm("Are you sure you want to delete this service?")) {
            return;
        }

        $.ajax({
            url: `${API_BASE_URL}/api/service/delete/${id}`,
            type: "DELETE",
            success: function () {
                showSuccessModal("Service Delete Successfully!");
                loadAllServices();
            },
            error: function (xhr) {
                console.error(xhr);
                alert("Failed to delete service!");
            }
        });
    });

});

// import $ from "jquery";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import API_BASE_URL from "../../../helper.js";

// // Function to show success modal
// function showSuccessModal(message) {
//     $("#successMessage").text(message);
//     const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
//     modal.show();
// }

// window.loadServices = function () {
//     loadAllServices();
// };

// $(document).ready(function () {

//     // Add Service
//     $("#addServiceForm").submit(function (e) {
//         e.preventDefault();

//         const formData = new FormData();
//         formData.append("name", $("#name").val());
//         formData.append("description", $("#discription").val());
//         formData.append("image", $("#image")[0].files[0]);

//         $.ajax({
//             url: `${API_BASE_URL}/api/service/add`,
//             type: "POST",
//             data: formData,
//             contentType: false,
//             processData: false,

//             success: function () {

//                 showSuccessModal("Service Added Successfully!");

//                 $("#addServiceForm")[0].reset();

//                 // Close Service Modal
//                 const serviceModal = window.bootstrap.Modal.getInstance(document.getElementById("serviceModal"));
//                 serviceModal.hide();

//                 loadAllServices(); 
//             },

//             error: function (xhr) {
//                 console.log(xhr);
//                 alert("Failed to add service!");
//             }
//         });
//     });

//     // Get All Service
//     function loadAllServices() {
//         $.ajax({
//             url: `${API_BASE_URL}/api/service/all`,
//             type: "GET",
//             success: function (services) {

//                 services.reverse();
//                 let rows = "";

//                 services.forEach((service, index) => {
//                     rows += `
//                         <tr>
//                             <td>${index + 1}</td>
//                             <td><img src="${API_BASE_URL}/assets/Images/${service.image}" width="80" height="80" /></td>
//                             <td>${service.name}</td>
//                             <td>${service.description}</td>
//                             <td>
//                                 <button class="btn btn-primary btn-sm editServiceBtn" data-id="${service.id}">Edit</button>
//                                 <button class="btn btn-danger btn-sm mx-1 deleteServiceBtn" data-id="${service.id}">Delete</button>
//                             </td>
//                         </tr>
//                     `;
//                 });

//                 $("#allSeviceData").html(rows);
//             },
//             error: function (xhr) {
//                 console.error("Failed to fetch services", xhr);
//             }
//         });
//     }

//     // OPEN EDIT MODAL
//     $(document).on("click", ".editServiceBtn", function () {
//         const id = $(this).data("id");

//         $.ajax({
//             url: `${API_BASE_URL}/api/service/get/${id}`,
//             type: "GET",
//             success: function (b) {

//                 $("#editId").val(b.id);
//                 $("#editName").val(b.name);
//                 $("#editDescription").val(b.description);

//                 new window.bootstrap.Modal(document.getElementById("editServiceModal")).show();
//             },
//             error: () => alert("Failed to fetch service data")
//         });
//     });

//     // UPDATE Service
//     $("#editServiceForm").submit(function (e) {
//         e.preventDefault();

//         const id = $("#editId").val();
//         const formData = new FormData();

//         formData.append("name", $("#editName").val());
//         formData.append("description", $("#editDescription").val());

//         if ($("#editImage")[0].files.length > 0) {
//             formData.append("image", $("#editImage")[0].files[0]);
//         }

//         $.ajax({
//             url: `${API_BASE_URL}/api/service/update/${id}`,
//             type: "POST",
//             contentType: false,
//             processData: false,
//             data: formData,
//             success: function () {
//                 showSuccessModal("Service Updated Successfully!");
//                 loadAllServices();
//                 window.bootstrap.Modal.getInstance(document.getElementById("editServiceModal")).hide();
//             },
//             error: () => alert("Failed to update Service")
//         });
//     });

//     // Delete Service
//     $(document).on("click", ".deleteServiceBtn", function () {
//         let id = $(this).data("id");

//         if (!window.confirm("Are you sure you want to delete this service?")) {
//             return;
//         }

//         $.ajax({
//             url: `${API_BASE_URL}/api/service/delete/${id}`,
//             type: "DELETE",
//             success: function () {
//                 showSuccessModal("Service Delete Successfully!");
//                 loadAllServices(); // refresh table
//             },
//             error: function (xhr) {
//                 console.error(xhr);
//                 alert("Failed to delete service!");
//             }
//         });
//     });


// });

